module.exports = __webpack_public_path__ + "media/images/products/category/8-3b4fb27a7a5ab1b533852af45402013a.jpg";